import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-brown-600 text-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16">
        {/* Top Section */}
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-5xl font-serif font-semibold mb-4">
            ジュエリーおかやま株式会社
          </h2>
          <p className="text-base lg:text-lg leading-relaxed max-w-2xl mx-auto mb-8 opacity-90">
            岡山で20年以上、お客様の大切な想いをカタチにしてきました。
          </p>
          
          {/* Social Icons */}
          <div className="flex items-center justify-center space-x-6 mb-12">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center border-2 border-white rounded-full hover:bg-white hover:text-brown-600 transition-all cursor-pointer"
              aria-label="Instagram"
            >
              <i className="ri-instagram-line text-xl"></i>
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center border-2 border-white rounded-full hover:bg-white hover:text-brown-600 transition-all cursor-pointer"
              aria-label="Facebook"
            >
              <i className="ri-facebook-fill text-xl"></i>
            </a>
            <a
              href="https://line.me"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center border-2 border-white rounded-full hover:bg-white hover:text-brown-600 transition-all cursor-pointer"
              aria-label="LINE"
            >
              <i className="ri-line-fill text-xl"></i>
            </a>
          </div>
        </div>

        {/* Info Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 mb-12">
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-4">所在地</h3>
            <p className="text-base leading-relaxed opacity-90">
              〒700-0000<br />
              岡山市北区○○町1-2-3
            </p>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-4">お問い合わせ</h3>
            <p className="text-base leading-relaxed opacity-90">
              TEL: 086-012-3456<br />
              FAX: 086-012-3457
            </p>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-4">営業時間</h3>
            <p className="text-base leading-relaxed opacity-90">
              9:00 〜 18:00<br />
              定休日：土曜日・祝日
            </p>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-white/30 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-sm opacity-75">
              © 2025 ジュエリーおかやま株式会社
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}